export default {
    allergyGetters: (state) => (storeKey: string, field: string) => {
      return  state.allergyDataByKey[storeKey] ? state.allergyDataByKey[storeKey][field] : null
    },
    dietsGetters: (state) => (storeKey: string, field: string) => {
        return  state.dietDataByKey[storeKey] ? state.dietDataByKey[storeKey][field] : null
    }
}
